import React, { createContext, useContext, useEffect, useState } from 'react';

// 1. Контекст жасаймыз
const ThemeContext = createContext();

// 2. Тақырыпты басқаратын Провайдер компонентін жасаймыз
export const ThemeProvider = ({ children }) => {
    // localStorage-дан сақталған тақырыпты немесе жүйенің тақырыбын аламыз
    const [theme, setTheme] = useState(() => {
        const storedTheme = localStorage.getItem('theme');
        if (storedTheme) {
            return storedTheme;
        }
        // Егер localStorage-да жоқ болса, қолданушының жүйесінің тақырыбын тексереміз
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    });

    // Тақырып өзгерген кезде, <html> тегіне класс қосып, localStorage-ға сақтаймыз
    useEffect(() => {
        const root = window.document.documentElement;
        
        root.classList.remove('light', 'dark');
        root.classList.add(theme);

        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };
    
    const value = { theme, toggleTheme };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
export const useTheme = () => {
    return useContext(ThemeContext);
};
